module.exports = __webpack_public_path__ + "static/polarpumpen-env2-min-a53797c5c3d949975d7b255b1159849b.jpg";